import { suggestOnuType, vendorFromSerial, type OnuTypeCandidate } from '@simpleacs/shared';

/**
 * The replacement model the Swap dialog opens on.
 *
 * A Huawei autofind names it. A ZTE `uncfg` does not, and the dialog used to
 * prefill the OUTGOING unit's model for the usual like-for-like RMA — which is
 * how two ZTE F670Ls that replaced Huawei HG8546Ms on gachie1 were declared
 * HG8546M (ZXICCD589429 on 2026-09-23, ZXICCD59425C on 2026-10-07): nothing
 * looked at the replacement's own serial. Like-for-like now holds only while
 * the serials name the same vendor; across vendors the library's own guess for
 * the replacement's serial is used (the model that vendor's units here mostly
 * are), and with no guess the field opens empty so somebody chooses.
 */
export function swapReplacementModel(input: {
  newSerial: string;
  detectedModel?: string | null;
  outgoingSerial: string;
  outgoingType: string | null;
  models: OnuTypeCandidate[];
}): string {
  const detected = input.detectedModel?.trim();
  if (detected) return detected;
  const incoming = vendorFromSerial(input.newSerial);
  const outgoing = vendorFromSerial(input.outgoingSerial);
  if (input.outgoingType && (!incoming || !outgoing || incoming === outgoing)) return input.outgoingType;
  return suggestOnuType(input.newSerial, input.models).match?.name ?? '';
}
